// extracted by mini-css-extract-plugin
export default {"globalSearchButton":"oTMA2VLb2Bn1aV0WFQTl","content":"erCqiIe1RieCBIBviwTg","shortcut":"Odtm1bDzVBwL7HNzLIAv","text":"fyzTt7ToBzNXrDhC8RbC"};